import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  profilePic: null,
  userName: null,
  userEmail: null,
  timezoneOffset: null,
  language: null,
  theme: null,
  mobileTheme: null,
  desktopTheme: null,
  // googleScope: null,
  promise: null,
  userPreferences: null,
  soundId: null,
  maxConn: null,
  dataStorage: null,
  systemTime: null,
  announcementList: [],
  notiEmail: null,
  pendingNotiEmail: null,
  encodingType: null,
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
